document.addEventListener('DOMContentLoaded', function() {
  const minimizarButton = document.getElementById('rbr-min-btn');
  if(!minimizarButton) return;
  const textButton = document.getElementById('rbr-text-btn');
  const textMin = document.getElementById('rbr-text-min');
  const borderFix = document.querySelector('.product__block.product__form__wrapper');
  minimizarButton.addEventListener('click', function() {
   const form = document.querySelector('.product__block.product__form__wrapper form');
   const elements = document.getElementById('rbr-container-element-true');
   const summaryBar = document.getElementById('summary-bar');
   minimizarButton.classList.toggle('not-expanded');
   form.classList.toggle('hidden');
   elements.classList.toggle('hidden');
   summaryBar.classList.toggle('hidden');
   textButton.classList.toggle('hidden');
   textMin.classList.toggle('hidden');
   borderFix.classList.toggle('border-fix');
  });
});